module.exports = __webpack_public_path__ + "media/application/images/svgs/maximize-c267c7895e69bdd8f1feaf3ab3ac8379.svg";